import React, { useEffect, useRef } from 'react';
import { Provider } from 'react-redux';
import { store } from '../store';
import { useAppState } from '../hooks/useRedux';

// Runs the auth check once on mount — refs prevent re-firing on every render
const AppInitializer = ({ children }) => {
  const { initializeApp, handleError } = useAppState();
  const initializeAppRef = useRef(initializeApp);
  const handleErrorRef = useRef(handleError);
  initializeAppRef.current = initializeApp;
  handleErrorRef.current = handleError;

  useEffect(() => {
    initializeAppRef
      .current()
      .catch(err => handleErrorRef.current(err, 'initialization'));
  }, []);

  return children;
};

const ReduxProvider = ({ children }) => {
  return (
    <Provider store={store}>
      <AppInitializer>{children}</AppInitializer>
    </Provider>
  );
};

export default ReduxProvider;
